
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationText } from '@/components/i18n/TranslationText';
import { 
  FileText, 
  Clock, 
  Bell, 
  BarChart3, 
  Users, 
  FileCheck 
} from 'lucide-react';

export function FeaturesSection() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: <FileText className="h-10 w-10 text-primary" />,
      titleKey: "features.contractManagement.title",
      descriptionKey: "features.contractManagement.description",
    },
    {
      icon: <Clock className="h-10 w-10 text-primary" />,
      titleKey: "features.reminders.title",
      descriptionKey: "features.reminders.description",
    },
    {
      icon: <BarChart3 className="h-10 w-10 text-primary" />,
      titleKey: "features.dashboards.title",
      descriptionKey: "features.dashboards.description",
    },
    {
      icon: <FileCheck className="h-10 w-10 text-primary" />,
      titleKey: "features.compliance.title",
      descriptionKey: "features.compliance.description",
    },
    {
      icon: <Bell className="h-10 w-10 text-primary" />,
      titleKey: "features.notifications.title",
      descriptionKey: "features.notifications.description",
    },
    {
      icon: <Users className="h-10 w-10 text-primary" />,
      titleKey: "features.collaboration.title",
      descriptionKey: "features.collaboration.description",
    },
  ];
  
  return (
    <section id="features" className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="container px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
            <TranslationText i18nKey="features.title">
              Take Control of Your Contracts
            </TranslationText>
          </h2>
          <p className="mt-4 text-muted-foreground md:text-lg">
            <TranslationText i18nKey="features.subtitle">
              Our platform provides everything you need to manage contracts efficiently
            </TranslationText>
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="rounded-full bg-primary/10 w-16 h-16 flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3">
                <TranslationText i18nKey={feature.titleKey}>
                  {t(feature.titleKey)}
                </TranslationText>
              </h3>
              <p className="text-muted-foreground">
                <TranslationText i18nKey={feature.descriptionKey}>
                  {t(feature.descriptionKey)}
                </TranslationText>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
